import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, ChevronLeft } from 'lucide-react';
import { axiosInstance } from '../../utils/axios';
import SideMenu from '../SessionCom/SideMenu';
import { useSignOut } from '../../hooks/useSignOut';
import './medichat_mypage.scss';

const PageHeader = ({ title, right = null, onBack = null }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axiosInstance.get('/api/medichat/profile');
        setUserProfile(data?.user || {});
      } catch {
        setUserProfile({});
      }
    })();
  }, []);

  const handleNewSession = useCallback(async () => {
    try {
      const { data } = await axiosInstance.post('/api/medichat/sessions', {});
      navigate(`/medichat/chat/${data.session?.id}`);
    } catch (e) {
      console.error('Failed to create session:', e);
    }
  }, [navigate]);

  const handleSignOut = useSignOut();

  return (
    <>
      <div className="mypage-header">
        {onBack ? (
          <button
            className="mypage-header__back"
            onClick={onBack}
            aria-label="戻る"
          >
            <ChevronLeft size={22} />
          </button>
        ) : (
          <button
            className="mypage-header__hamburger"
            onClick={() => setMenuOpen(true)}
            aria-label="メニューを開く"
          >
            <Menu size={22} />
          </button>
        )}
        <div className="mypage-header__title">{title}</div>
        <div className="mypage-header__right">{right}</div>
      </div>
      {!onBack && (
        <div className="mypage-sidemenu-host">
          <SideMenu
            isOpen={menuOpen}
            onClose={() => setMenuOpen(false)}
            onNewSession={handleNewSession}
            userProfile={userProfile}
            onSignOut={handleSignOut}
          />
        </div>
      )}
    </>
  );
};

export default PageHeader;
